module.exports = __webpack_public_path__ + "files/815a3f54f4328792aea942752e64f389.png";